import api from '@/shared/api/api-client';

import type { AccountDraft } from '../domain/account-draft.model';
import type { AccountSettingsGateway } from './account-settings.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the account-update endpoint and body mapping. Hits the self endpoint
 * `PATCH /account`: the backend derives the user from the session, so no id is
 * sent (the account hexagon enforces self-scope by construction).
 *
 * `email` is deliberately NOT sent. The sign-in address is a credential: it moves
 * through `POST /account/email` (re-authenticated) plus the link confirmed at the
 * new address, and `PATCH /account` no longer declares the field at all: Fastify
 * would strip it, so sending it would show a success snackbar for a change that
 * never happened. See PI-34.
 */
export const httpAccountSettingsGateway: AccountSettingsGateway = {
  updateAccount: async (draft: AccountDraft) => {
    await api.patch('/account', {
      first_name: draft.firstName.trim(),
      last_name: draft.lastName.trim(),
    });
  },

  uploadAvatar: async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    const { avatar_url } = await api.upload<{ avatar_url: string }>('/account/avatar', formData);
    return avatar_url;
  },

  removeAvatar: async () => {
    await api.delete('/account/avatar');
  },
};
